module.exports = __webpack_public_path__ + "img/walk-q4-1.ef0f65e1.png";